/**
 * Classifies whether numeric salary fields on a job are backed by quoted text from the listing.
 * Used to label compensation UI: employer-stated vs extracted without a verifiable quote.
 */

export type JobSalaryListingProvenance = 'none' | 'employer_quote' | 'extracted_without_quote';

function hasPositiveNumericSalaryRange(
  salaryRangeMin: unknown,
  salaryRangeMax: unknown,
): boolean {
  return (
    typeof salaryRangeMin === 'number' &&
    typeof salaryRangeMax === 'number' &&
    Number.isFinite(salaryRangeMin) &&
    Number.isFinite(salaryRangeMax) &&
    salaryRangeMin > 0 &&
    salaryRangeMax > 0
  );
}

/**
 * @param salaryDetails - Localised salary quote from the processor (verbatim excerpt from the ad when rules are followed).
 */
export function resolveJobSalaryListingProvenance(input: {
  salaryRangeMin?: number | null;
  salaryRangeMax?: number | null;
  salaryDetails?: string | null;
}): JobSalaryListingProvenance {
  if (!hasPositiveNumericSalaryRange(input.salaryRangeMin, input.salaryRangeMax)) {
    return 'none';
  }
  const detail = typeof input.salaryDetails === 'string' ? input.salaryDetails.trim() : '';
  if (detail.length > 0) {
    return 'employer_quote';
  }
  return 'extracted_without_quote';
}
